import { render } from "./videos.vue?vue&type=template&id=5f11bb22&scoped=true"
import script from "./videos.vue?vue&type=script&lang=js"
export * from "./videos.vue?vue&type=script&lang=js"

import "./videos.vue?vue&type=style&index=0&id=5f11bb22&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/blog/blog/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f11bb22"]])

export default __exports__